import React from 'react';
import PropTypes from 'prop-types';
import { Radios } from '@ontruck/orc';
import Extra from 'components/form/Extra';
import { constants as extrasConstants } from 'utils/extras';
import Tooltip from 'components/Tooltip';
import { GirdedQuestionIcon } from 'refactored/ui/icons';
import { Title } from 'refactored/ui/typography';

const calculateSideLoad = (item) =>
  item.includes('SIDE_LOAD') ? 'SIDE_LOAD' : 'REMOVE_LIFTGATE_SIDE_LOAD';

const VehicleExtras = ({
  className,
  title,
  t,
  extrasKeys,
  extrasInOrder,
  handleExtra,
}) => {
  const calculatedRadioValue = extrasInOrder.includes('LIFTGATE')
    ? 'LIFTGATE'
    : calculateSideLoad(extrasInOrder);
  const checkboxKeys = extrasKeys.filter(
    (extra) => !extrasConstants.RADIOS_EXTRAS.includes(extra)
  );

  return (
    <div className={className}>
      <Title level="h3">
        {title}
        <Tooltip
          className="title-tooltip"
          component={t(`directHelper`)}
          segmentTitle="form extras title"
        >
          <GirdedQuestionIcon />
        </Tooltip>
      </Title>

      {extrasKeys.includes('LIFTGATE') && extrasKeys.includes('SIDE_LOAD') && (
        <div className="radios-container">
          <Radios
            size="L"
            name="extras"
            items={[
              { value: 'LIFTGATE', label: t(`extras.LIFTGATE.label`) },
              { value: 'SIDE_LOAD', label: t(`extras.SIDE_LOAD.label`) },
              { value: 'REMOVE_LIFTGATE_SIDE_LOAD', label: t('none') },
            ]}
            value={calculatedRadioValue}
            onChange={(e, { value }) =>
              handleExtra({ target: { name: value } })
            }
          />
        </div>
      )}

      <div>
        {checkboxKeys.map((extraKey) => (
          <Extra
            key={extraKey}
            name={extraKey}
            className="extra"
            handleChange={handleExtra}
            label={t(`extras.${extraKey}.label`)}
            tooltip={t(`extras.${extraKey}.tooltip`)}
            checked={extrasInOrder.includes(extraKey)}
            disabled={
              (extraKey === 'LIFTGATE' &&
                extrasInOrder.includes('SIDE_LOAD')) ||
              (extraKey === 'SIDE_LOAD' && extrasInOrder.includes('LIFTGATE'))
            }
          />
        ))}
      </div>
    </div>
  );
};

VehicleExtras.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func,
  handleExtra: PropTypes.func,
  extrasKeys: PropTypes.arrayOf(PropTypes.string),
  extrasInOrder: PropTypes.arrayOf(PropTypes.string),
};

VehicleExtras.defaultProps = {
  className: '',
  title: '',
  t: (t) => t,
  handleExtra: () => ({}),
  extrasKeys: [],
  extrasInOrder: [],
};

export default VehicleExtras;
